import React from 'react'
import { Heading } from '@myxplor/ui'

const AdditionalConditions = ({ agreement_conditions }) =>
  !!agreement_conditions ? (
    <div className="formSection">
      <Heading small compact>
        Additional Conditions
      </Heading>

      <div className="enrolmentSchedule--additionalConditions">{agreement_conditions}</div>
    </div>
  ) : null

export default AdditionalConditions



// WEBPACK FOOTER //
// ./src/parent-agreement/views/additional-conditions.jsx